import {
  ElementCategoryID,
  IElementCategory,
} from '@shared/models/element-categories.model';
import { DEFAULT_QUANTITY_PROPERTIES } from '@shared/models/element-quantities.model';
import { omit } from 'lodash';
import { systemElementCategoryProperties } from '../common-element-category-properties.model';

/**
 * Main category other
 */
export const other: IElementCategory = {
  properties: systemElementCategoryProperties,
  getQuantityProperties: () =>
    omit(DEFAULT_QUANTITY_PROPERTIES, 'density', 'mass', 'fill'),
  id: ElementCategoryID.Other,
  name: 'Other',
  getElementPropertySelectionByProductId: () => undefined,
};
